export default {
    breadcrumb: {
        project: 'Repository',
    },
    sizeUnit: {
        mb: 'MB',
        kb: 'KB',
        b: 'B',
    },
    header: {
        name: 'Name',
        type: 'Type',
        modifiedDate: 'Modified date',
        size: 'Size',
        action: 'Action',
    },
    action: {
        import: 'Import',
        open: 'Open',
        rename: 'Rename',
        download: 'Download',
        delete: 'Delete',
    },
};
